import FnrFetch3, { callMockResponse } from "Utilities/FnrFetch/FnrFetch3.js";
import { mockData } from "./mockData";

const API = {
  sendAuthCode: (postData) =>
    mockData.shouldMock
      ? callMockResponse(mockData.requestAuthCodeResponse)
      : new FnrFetch3(`/login/sendFlexibleAuthCode`, postData),

  loginWithAuthCode: (postData) =>
    mockData.shouldMock
      ? callMockResponse(mockData.verifyAuthCodeResponse)
      : new FnrFetch3(`/give/loginWithAuthCode`, postData),

  submitPayment: (postData) =>
    mockData.shouldMock
      ? callMockResponse(mockData.submitPaymentResponse)
      : new FnrFetch3(`/give/submitPayment`, postData),

  getPaymentStatus: (postData) =>
    mockData.shouldMock
      ? callMockResponse(mockData.createMockPollingPaymentResponse())
      : new FnrFetch3(`/give/getPaymentStatus`, postData),

  declineReceived: (postData) =>
    mockData.shouldMock
      ? callMockResponse(mockData.declineReceivedResponse)
      : new FnrFetch3(`/give/declineReceived`, postData),

  cancelPayment: (postData) =>
    mockData.shouldMock
      ? callMockResponse(mockData.cancelPaymentResponse)
      : new FnrFetch3(`/give/cancelScheduledPayment`, postData),

  log: (postData) => new FnrFetch3(`/give/log`, postData),
};

export default API;
